function Wrap(
    containerStyle: React.CSSProperties | undefined
): React.CSSProperties {
    const carousel: React.CSSProperties = {
        ...containerStyle,
        position: 'relative',
        width: '100%',
        maxWidth: '100vw',
        margin: '0 auto',
        padding: 'auto 50%'
    }
    return carousel;
};

export function GridWrap(
    containerStyle: React.CSSProperties | undefined
): React.CSSProperties {
    const carouselStyle = Wrap(containerStyle);
    const carouselHidden = {
        ...carouselStyle,
        overflow: 'visible',
        cursor: 'grab',
    };
    return carouselHidden;
};

export function CarouselWrap(
    containerStyle: React.CSSProperties | undefined
): React.CSSProperties {
    const carouselStyle = Wrap(containerStyle);
    const carouselHidden = {
        ...carouselStyle,
        overflow: 'hidden',
        cursor: 'default',
    };
    return carouselHidden;
};
